<template>
   <!-- ℹ️ This component displays a legacy study card with its documents. 
 Legacy studies were launched before the concept of study participation existed, so they don't appear on the user account page. 
 As a result, participants of legacy studies currently have no access to documents previously released to them. -->
   <div
      v-if="clientSettings.userDocuments.isActive"
      class="mb-8 rounded-3xl border border-grey-20 p-6 text-base leading-snug text-black md:p-8"
      data-cy="user-legacy-study-card"
   >
      <div class="mb-10 flex flex-col gap-x-8 gap-y-4 md:flex-row">
         <div class="flex w-full flex-col gap-x-8 gap-y-4 md:flex-row md:flex-wrap">
            <div class="flex grow flex-col gap-y-4 md:basis-[40ch]" :class="'max-w-60ch'">
               <h3 class="text-bolder text-xl" data-cy="study-title">{{ studyTitle }}</h3>
            </div>
         </div>
      </div>
      <div data-cy="study-reports" v-if="studyReports.length">
         <h4 class="text-bolder text-lg mb-4" data-cy="study-reports-title">Study reports</h4>
         <DocumentsTable :docs="studyReports" />
      </div>
      <div data-cy="other-documents" v-if="otherDocuments.length">
         <h4 v-if="studyReports.length" class="text-bolder text-lg mb-4 mt-8" data-cy="other-documents-title">
            Other documents
         </h4>
         <DocumentsTable :docs="otherDocuments" />
      </div>
   </div>
</template>
<script setup lang="ts">
import { useClientSettingsKey } from "@/plugins/useClientSettings";
import type { DocumentResp } from "@/data/api-layer/documentsApi";
import { studyReportTypes } from "@/constants/study-reports.ts";

// Declarations
// ---------------------------
const clientSettings = inject(useClientSettingsKey);

interface Props {
   studyId: string;
   docs: DocumentResp[];
}

const props = defineProps<Props>();

// Computed
// ---------------------------
const studyTitle = computed(() => props.docs[0].study.title);
const studyReports = computed(() => props.docs.filter((doc) => studyReportTypes.includes(doc.type?.name)));
const otherDocuments = computed(() => props.docs.filter((doc) => !studyReportTypes.includes(doc.type?.name)));
</script>
